import * as React from "react";
import { ListBoxProps } from "./list-box";

const ListBoxContext = React.createContext<{ props: ListBoxProps<any> } | null>(
  null
);

export function ListBoxProvider(
  props: React.PropsWithChildren<ListBoxProps<any>>
) {
  return (
    <ListBoxContext.Provider value={{ props }}>
      {props.children}
    </ListBoxContext.Provider>
  );
}

export function useListBoxContext() {
  const ctx = React.useContext(ListBoxContext);
  if (!ctx) {
    throw new Error(
      "ListBox components must be rendered within the ListBoxProvider"
    );
  }

  return ctx;
}
